import { VendorVerrechnetPage } from "../vendor-verrechnet.page";
import { useCentralStore } from "../../../store/Central";

export const VendorVerrechnetPageConnected = () => {
	const organizationId = useCentralStore((s) => s.organization?.id ?? "");
	return <VendorVerrechnetPage organizationId={organizationId} />;
};
